<script>
    // @ts-nocheck
    import { Router, Route, navigate, useLocation } from 'svelte-navigator'
    import { fly, fade } from 'svelte/transition'
    import searchlogo from '../assets/pictures/search.svg'
    import { clickOutside, formatCUIT, strftime } from '$lib/utils'
    import {
        buildFilterCompilator,
        isoDateFilter,
    } from '$lib/services/dynamicFilters'
    import { API_URL, ENV } from '$lib/conf'
    import user from '$lib/stores/user'
    import { writable } from 'svelte/store'
    import invoices, { createDerived } from '$lib/services/collections/invoices_sin'
    import provider from '$lib/stores/provider'
    import dictionaries from '$lib/stores/dictionaries'
    import waitingDocuments from '$lib/stores/countWaiting'
    import { currencyFormatter } from '$lib/utils'
    import { onMount, getContext } from 'svelte'
    import { DamageInvoice as Invoice } from '$lib/services/interfaces'
    // import { db } from '$lib/services/db'
    import { liveQuery } from '$lib/services/livequery'
    import TopBar from '$lib/components/layout/TopBar.svelte'
    import {
        Banner,
        ScrollBox,
        Typography,
        TertiaryButton,
        FormBoxContainer,
        FormBoxRow,
        FormBoxCell,
        Chip,
        BackDrop,
        Link,
        Row,
        InputText,
        Alert,
        Spinner,
        Paginator,
        Button,
    } from '$lib/components/UI/'
    import Datatable from '$lib/components/UI/DatatableX.svelte'
    import InputDate from '$lib/components/UI/InputDate.svelte'
    import { SyncOutline } from '$lib/components/Icons'
    import { default as filterIcon } from '../assets/pictures/f28-filter-funnel.svg'
    import { default as notFoundDoc } from '../assets/pictures/f64-printer.svg'
    import Docs from '$lib/components/Icons/custom/Docs.svelte'
    import Close from '$lib/components/Icons/custom/Close.svelte'
    import DatatableX from '$lib/components/UI/DatatableX.svelte'
    import WidgetFactura from '$lib/custom/components/WidgetFactura.svelte'
    export let customFilter = (r) => true
    export let maskState = {}
    let dynamicFilter = [
        // [true, i => i.cuit_proveedor === $user?.defaultAccount]
    ] // Arreglo de tuplas [assert<Bool>, filter<Function>]
    let showFilters = false
    let dataFilter = {
        search: '',
        fc_desde: 0,
        fc_hasta: 0,
    }
    let siteUrl = ENV.API_URL.split('/').slice(0, -1).join('/')
    const toast = getContext('toast')
    const schema_percepciones = {
        provincia: {
            render: (v) =>
                $dictionaries.vprovincias?.find((t) => t.value === v)
                    ?.label || '',
        },
        desc: {
            label: 'Descripcion',
            render: (_, item) =>
                $dictionaries.lic_percepciones?.find(
                    (t) => t.value === item?.percepcion
                )?.label || '',
        },
        // percepcion: {
        //     label: 'Percepción',
        // },
        monto: {
            label: 'Monto',
            render: (n) =>
                n ? currencyFormatter({ n, type: 'ARS', lang: 'es-AR' }) : '-',
        },
    }
    let currentPage
    const refStates = {
        Ingresada: { alt: 'Factura ingresada', color: '#6F7072', icon: '' },
        'En trámite': {
            alt: 'Factura en trámite de aprobación, está siendo procesada.',
            // label: "En trámite",
            color: '#FF9F00',
            icon: '',
        },
        Pendiente: {
            alt: 'Factura en trámite de aprobación, está siendo procesada.',
            // label: "En trámite",
            color: '#FF9F00',
            icon: '',
        },
        'A Completar': {
            alt: 'Factura pendiente de completar.',
            // label: "En trámite",
            color: '#FF9F00',
            icon: '',
        },
        Rechazada: {
            alt: 'La factura fué rechazada.',
            label: 'Rechazada',
            color: '#AF2219',
            icon: '',
        },
        Aprobada: {
            alt: 'Su pago fué aprobado.',
            color: '#7ED321',
            icon: '',
        },
        Pagada: {
            alt: 'El pago de la factura ha sido realizado.',
            color: '#7ED321',
            icon: '',
        },
    }
    function getDate(date, type = 'locale') {
        if (typeof date === 'number') {
            let tmpDate = new Date(date * 1000)
            if (type === 'locale') {
                return `${String(tmpDate.getDate()).padStart(2, '0')}/${String(tmpDate.getMonth() + 1).padStart(2, '0')}/${tmpDate.getFullYear()}`
            } else if (type === 'iso') {
                return `${tmpDate.getFullYear()}-${String(tmpDate.getMonth() + 1).padStart(2, '0')}-${String(tmpDate.getDate()).padStart(2, '0')}`
            } else {
                return ''
            }
        } else {
            return ''
        }
    }
    function formatPatente(value) {
        return typeof value == 'string' && /\d/.test(value[2])
            ? `${value.substr(0, 2)} ${value.substr(2, 3)} ${value.substr(5, 2)}`
            : `${value.substr(0, 3)} ${value.substr(3, 3)}`
    }
    let sortDirective = writable(['creation_date'])
    // const invoices = liveQuery(db.invoices_sin, Invoice);
    const location = useLocation()
    const getRegex = (v, f = '') => {
        return new RegExp(v, f)
    }
    const filterCompilator = buildFilterCompilator((t) =>
        t
            .where('id_proveedor')
            .equals($user?.currentIdAccount)
            .and(customFilter)
    )
    const searchMainFilter = (val, cond = () => true) => [
        cond(val), //   Assert (default search)
        (f) =>
            f.filter((item) => {
                // Custom filter (default search)
                return (
                    [
                        'uuid',
                        'total',
                        'cuit_proveedor',
                        'cuit_destinatario',
                        'no_siniestro',
                        'state',
                        'patente',
                        'creation_date',
                    ].some((x) =>
                        getRegex(
                            `${val.replace(/[^\x00-\x7F]+/g, '.')}`,
                            'i'
                        ).test(item[x])
                    ) ||
                    getRegex(val).test(getDate(item.creation_date)) ||
                    getRegex(val).test(getDate(item.creation_date), 'iso')
                )
            }),
    ]
    function search(val) {
        currentPage = 1
        dynamicFilter = [searchMainFilter(val)]
        if (val == '') {
            clearFilter()
        }
    }
    let inputValue = ''
    $: visible = $location.pathname !== '/home/invoices'
    const clearFilter = (_) => {
        inputValue = ''
        dynamicFilter = [] // clear filters
    }
    let dataForm = {}
    $: if ($provider || dataForm) {
        dataForm.email = $provider.data.email_dp
    }
    const schema = {
        no_siniestro: { label: 'No. Siniestro' },
        creation_date: {
            label: 'Fecha de recepción',
            render: (r) => strftime('%d/%m/%Y', new Date(r)),
        },
        patente: {
            type: Chip,
            // render: (v) => `<strong>${v}</strong>`,
            props: (p) => ({
                style: 'border-radius: 3px',
                color: 'gray',
                alt: `Patente: ${p}`,
            }),
            render: formatPatente,
        },
        state: {
            label: 'Estado',
            type: Chip,
            render: s => {
                console.log({render: s})
                return s in maskState ? maskState[s] : s
            },
            props: (state) => {
                return getState(state)
                // let prop = state in refStates
                //     ? refStates[state]
                //     : { label: state, color: 'gray' }
                // let {label: estado} = prop
                // if (estado) estado = estado in maskState ? maskState[estado] : estado
                // return {...prop, ...(estado ? {label: estado} : {})}
            }
        },
        total: {
            render: (r) =>
                r
                    ? currencyFormatter({ n: r, lang: 'es-AR', type: 'ARS' })
                    : '-',
        },
        // subtotal: {
        //     render: r => currencyFormatter({n: r, lang: 'es-AR', type: 'ARS'})
        // }
    }
    let paginatorObj = {}
    $: if (showFilters === true) {
        dynamicFilter = [
            // multiKeyFilter(dataFilter?.id || '', ['id_ath', 'ref']),
            searchMainFilter(dataFilter.search, (v) => !!v),
            isoDateFilter(
                [dataFilter?.fc_desde || null, dataFilter?.fc_hasta || null],
                'creation_date',
                -3
            ),
        ]
    }
    // $: console.log({dataFilter})
    $: if (showFilters === false) {
        clearFilter()
    }
    $: invoices.liveQuery(filterCompilator(dynamicFilter)) // Reactive filter
    let currentInvoice = null
    let waiting = false
    function updateInvoice({ detail: payload }) {
        waiting = true
        let { id, offer, ...updateData } = payload
        updateData = Object.fromEntries(
            Object.entries(updateData)
            .filter(([k]) => ['no_siniestro', 'patente', 'punto_venta', 'no_factura', 'fecha_factura', 'tipo_factura', 'letra', 'cuit_proveedor', 'cuit_destinatario', 'cae', 'vencimiento_cae', 'percepcion', 'iva', 'subtotal', 'total', 'id_factura', 'id_proveedor', 'motivo_rechazo', 'reemplazada'].includes(k))
        )
        let idToast = toast.loading('Cargando datos...')
        let request = Invoice.update(id, updateData)
            .then(async (req) => {
                if (req.ok) {
                    let res = await req.json()
                    let finalData = { ...payload, ...res }
                    console.log('OK', { res, payload, finalData })
                    currentInvoice = null
                    invoices.refresh()
                    toast && toast.success('Se guardaron los cambios de la factura.')
                    navigate(`/home/invoices/${id}`)
                } else {
                    if (req.status === 406) {
                        toast && toast.error('Se rechazó la factura.')
                    }
                    if (req.status === 404) {
                        toast && toast.error('No se encontró la factura que desea actualizar.')
                    }
                    currentInvoice = null
                    throw new Error()
                }
            })
            .finally(() => {
                toast && toast.remove(idToast)
                waiting = false
            })
        // toast &&
            // toast.promise(request, {
            //     loading: 'Cargando datos...',
            //     success: null,
            //     error: null
                // success: 'Se guardaron los cambios de la factura.',
                // error: 'Ocurrió un error al intentar actulizar la documentación.',
            // })
    }

    function loadInvoice({ detail: payload }) {
        waiting = true
        let request = Invoice.add(payload)
            .then(async (req) => {
                if (req.ok) {
                    let res = await req.json()
                    let finalData = { ...payload, ...res }
                    await invoices.add(res)
                    currentInvoice = null
                } else {
                    currentInvoice = null
                    throw new Error()
                }
            })
            .finally(() => {
                waiting = false
            })
        toast &&
            toast.promise(request, {
                loading: 'Subiendo factura...',
                success: 'Se subió la factura.',
                error: 'Ocurrió un error al cargar la factura.',
            })
    }
    const getState = (state) => {
        let prop = state in refStates
            ? refStates[state]
            : { label: state, color: 'gray' }
        let {label: estado} = prop
        if (estado) estado = estado in maskState ? maskState[estado] : estado
        return {...prop, label: estado || state}
    }
    const invoices2 = createDerived($user?.defaultAccount)
    let currentItem = null
    $: loadNewInvoice = currentInvoice && currentInvoice?.file !== undefined
    $: console.log({ invoices: $invoices2 })
    let currentItemAux = null
</script>

<!-- <div style="width: 100%; padding: 50px 70px; display: flex; flex-direction:column; align-items: center; gap: 20px; position: relative"> -->
<Router primary={false}>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <FormBoxContainer title="Mis Facturas" icon={Docs}>
        <svelte:fragment slot="option">
            <span
                on:click={(_) =>
                    invoices.sync({ cuit_proveedor: $user?.defaultAccount })}
                title="Sincronizar"
            >
                <SyncOutline size={25} />
            </span>
            <span on:click={(_) => (showFilters = !showFilters)}>
                {#if !showFilters}
                    <img
                        src={filterIcon}
                        title="Filtros"
                        width="25px"
                        alt="Filtros"
                    />
                {:else}
                    <Close color="#00669E" />
                {/if}
            </span>
        </svelte:fragment>
        {#await invoices.init({ cuit_proveedor: $user?.defaultAccount })}
            <span
                style="position: relative;width: 100%; height: 150px; display: flex; justify-content: center; align-items:center"
            >
                <Spinner />
            </span>
        {:then _}
            {#if showFilters}
                <span style="padding: 24px">
                    <Typography type="subhead">Buscar</Typography>
                    <Row>
                        <InputText
                            on:keyup={(_) => (currentPage = 1)}
                            bind:value={dataFilter.search}
                        />
                    </Row>
                    <Typography type="subhead">Fecha de creación</Typography>
                    <Row>
                        <InputDate
                            on:change={(_) => (currentPage = 1)}
                            label="Desde"
                            bind:value={dataFilter.fc_desde}
                        />
                        <InputDate
                            on:change={(_) => (currentPage = 1)}
                            label="Hasta"
                            bind:value={dataFilter.fc_hasta}
                        />
                    </Row>
                    {#if !([dataFilter.fc_desde, dataFilter.fc_hasta].every((t) => t !== undefined && typeof t === 'string' && t !== '') && dataFilter.fc_hasta.localeCompare(dataFilter.fc_desde) !== -1)}
                        <Alert type="error"
                            >"Hasta" debe ser posterior a "Desde"</Alert
                        >
                    {/if}
                    <p>
                        Resultados totales: <strong>{$invoices.length}</strong>
                    </p>
                    <!-- <Chip color="grey">Resultados totales: {$invoices.length}</Chip> -->
                </span>
            {:else}
                <span class="search">
                    <img src={searchlogo} alt="" draggable="false" />
                    <input
                        type="search"
                        placeholder="Buscar"
                        bind:value={inputValue}
                        on:input={(_) => search(inputValue)}
                    />
                </span>
            {/if}
            <Datatable
                data={invoices}
                {schema}
                bind:sortDirective
                bind:pagination={paginatorObj}
                bind:currentPage
                waitingSignals={waitingDocuments}
            >
                <svelte:fragment slot="noContent">
                    <img
                        src={notFoundDoc}
                        height="75px"
                        alt=""
                        style="margin: 0;padding:0; width: auto"
                    />
                    <Typography style="margin: 0; padding: 0" type="body"
                        >No se encontraron Facturas.</Typography
                    >
                </svelte:fragment>
                <svelte:fragment slot="endOfRow" let:item>
                    <span
                        style="display: flex; flex-direction: rows; gap: 15px"
                    >
                        {#if item.state == 'A Completar'}
                            <Button
                                style="width: fit-content; padding: 0"
                                size="small"
                                on:click={() => (currentInvoice = item)}
                                label="Completar"
                            />
                        {:else}
                            <TertiaryButton
                                label="ver"
                                on:click={() => {
                                    currentItem = item
                                    navigate(`/home/invoices/${item.id}`)
                                }}
                            />
                        {/if}
                    </span>
                </svelte:fragment>
            </Datatable>
        {/await}
    </FormBoxContainer>

    {#if ($invoices || []).length > 0}
        <div style="margin: 20px auto; width: fit-content">
            <Paginator {...paginatorObj} bind:currentPage />
        </div>
    {/if}
    <Route path="/:id" let:params>
        <BackDrop style="z-index: 999999; position: fixed" {visible}>
            <div
                class="drawer"
                transition:fly={{ x: 50 }}
                use:clickOutside
                on:clickout={(_) => navigate('/home/invoices')}
            >
                <TopBar
                    title="Detalle de Factura"
                    on:back={(_) => navigate($location?.state?.ref || -1)}
                >
                    <svelte:fragment slot="bar">
                        <Button
                            label="Ir a la oferta"
                            size="small"
                            type="transparent"
                            style="margin: 0 15px 0 0"
                            on:click={() => {
                                currentItem ? user.navigate(`/home/ofertas/${currentItem.offer.id}/view`) : navigate(-1)
                            }}
                        />
                    </svelte:fragment>
                    {#await invoices.get(params.id, true)}
                        <Spinner />
                    {:then invoice}
                        <!-- {@const percepciones = invoice.percepcion ? invoice.percepcion.split('|') : []} -->
                        <div
                            transition:fade|local
                            style="position: absolute;width: 100%; height: 100%; display: flex; flex-direction: column; position: relative"
                        >
                            <Banner
                                title={`FACT ${invoice.no_factura}`}
                                label="factura"
                                style=""
                                info={[
                                    {
                                        label: 'CUIT',
                                        value:
                                            formatCUIT(
                                                invoice.cuit_proveedor
                                            ).replace(/\s/g, '') || '-',
                                    },
                                    {
                                        label: 'Fecha de ingreso',
                                        value: strftime(
                                            '%d/%m/%Y',
                                            new Date(invoice.creation_date)
                                        ),
                                    },
                                    {
                                        label: 'Fecha de facturación',
                                        value: invoice.fecha_factura
                                            ? strftime(
                                                  '%d/%m/%Y',
                                                  new Date(
                                                      invoice.fecha_factura
                                                  )
                                              )
                                            : '...',
                                    },
                                    {
                                        label: 'Estado',
                                        value: getState(invoice.state).label
                                            // invoice.state in refStates &&
                                            // 'label' in refStates[invoice.state]
                                            //     ? refStates[invoice.state].label
                                            //     : invoice.state,
                                    },
                                ]}
                            />
                            <ScrollBox width="100%" height="calc(100% - 60px)">
                                <!-- height="calc(100% - 43px)" -->
                                <span
                                    style="padding:32px 70px; gap: 14px; display: flex; flex-direction: column; flex-wrap: wrap"
                                >
                                    {#if invoice.state == 'Rechazada'}
                                        <Alert type="error">
                                            <span
                                                style="display: flex; flex-direction: rows; justify-content: space-between"
                                            >
                                                <span>
                                                    <Typography
                                                        style="margin: 0 0 5px 0"
                                                        type="subtitle-medium"
                                                        >Motivos de rechazo:</Typography
                                                    >
                                                    {@html invoice.motivo_rechazo
                                                        .split('\n')
                                                        .map(
                                                            (i) =>
                                                                `<li>${i}</li>`
                                                        )
                                                        .join('\n')}
                                                </span>
                                                <Button
                                                    disabled={invoice.reemplazada}
                                                    style="margin: auto 0"
                                                    on:click={() =>
                                                        (currentInvoice = {
                                                            ...invoice,
                                                            file: [],
                                                            insteadOf:
                                                                invoice.id,
                                                        })}
                                                    label="Cargar otra"
                                                    size="small"
                                                />
                                            </span>
                                        </Alert>
                                    {/if}
                                    <FormBoxContainer
                                        title="Información de la Factura"
                                    >
                                        <FormBoxRow>
                                            <FormBoxCell
                                                label="Patente"
                                                value={formatPatente(
                                                    invoice.patente
                                                )}
                                            />
                                        </FormBoxRow>
                                        <FormBoxRow>
                                            <FormBoxCell
                                                label="Nro. de Comprobante"
                                                value={invoice.no_factura
                                                    ? invoice.no_factura.padStart(
                                                          8,
                                                          '0'
                                                      )
                                                    : '...'}
                                            />
                                            <FormBoxCell
                                                label="Punto de Venta"
                                                value={invoice.punto_venta
                                                    ? invoice.punto_venta.padStart(
                                                          5,
                                                          '0'
                                                      )
                                                    : '...'}
                                            />
                                        </FormBoxRow>
                                        <FormBoxRow>
                                            <FormBoxCell
                                                label="Tipo de Factura"
                                                value={invoice.letra || '...'}
                                            />
                                            <FormBoxCell
                                                label="CAE/CAI"
                                                value={invoice.cae || '...'}
                                            />
                                            <FormBoxCell
                                                label="Fecha de vencimiento CAE"
                                                value={invoice.vencimiento_cae ||
                                                    '...'}
                                            />
                                        </FormBoxRow>
                                        <FormBoxRow>
                                            <FormBoxCell
                                                label="CUIT de Facturación"
                                                value={invoice.cuit_destinatario ||
                                                    '...'}
                                            />
                                        </FormBoxRow>
                                        <FormBoxRow>
                                            <FormBoxCell
                                                label="IVA"
                                                value={invoice.iva >= 0
                                                    ? currencyFormatter({
                                                          n: invoice.iva,
                                                          lang: 'es-AR',
                                                          type: 'ARS',
                                                      })
                                                      //+ ` (${Math.ceil((invoice.iva / invoice.subtotal) * 100)}%)`
                                                    : '...'}
                                            />
                                            <FormBoxCell
                                                label="Subtotal"
                                                value={invoice.subtotal
                                                    ? currencyFormatter({
                                                          n: invoice.subtotal,
                                                          lang: 'es-AR',
                                                          type: 'ARS',
                                                      })
                                                    : '...'}
                                            />
                                            <FormBoxCell
                                                label="Importe Total"
                                                value={invoice.total
                                                    ? currencyFormatter({
                                                          n: invoice.total,
                                                          lang: 'es-AR',
                                                          type: 'ARS',
                                                      })
                                                    : '...'}
                                            />
                                        </FormBoxRow>
                                        {#if ENV.DEV}
                                            <FormBoxRow>
                                                <FormBoxCell>
                                                    <a
                                                        href={`${siteUrl}/file/view/${params.id}`}
                                                        target="_blank"
                                                        >{`${siteUrl}/file/view/${params.id}`}</a
                                                    >
                                                    <!-- <Link on:click={() => {
                                                        user.navigate(`${siteUrl}/file/view/${params.id}`, '_blank')
                                                    }}>{`${siteUrl}/file/view/${params.id}`}</Link> -->
                                                </FormBoxCell>
                                            </FormBoxRow>
                                        {/if}
                                    </FormBoxContainer>
                                    {#if invoice.percepcion.length > 0}
                                        <Typography style="margin-bottom: 0px"
                                            >Percepciones</Typography
                                        >
                                        <DatatableX
                                            initialData={invoice.percepcion}
                                            schema={schema_percepciones}
                                        />
                                        <!-- <span style="width: auto; margin: 0 0 25px 0; display: flex; gap: 10px; flex-wrap: wrap">
                                                {#each percepciones as perc}
                                                    <Chip style="border-radius: 5px; background: grey" alt={perc}>
                                                        {($dictionaries.lic_percepciones || []).find(t=> t.value === perc)?.label || 'Unknow'}
                                                    </Chip>
                                                {/each}
                                            </span> -->
                                    {/if}
                                    <Alert type="info"
                                        >En caso de duda, comunicarse con el
                                        área a la cual se brindó el servicio.</Alert
                                    >
                                    <span class="buttonSet">
                                        <!-- <Button
                                            type="secondary"
                                            on:click={(_) => {
                                                window.open(
                                                    'https://www.cobranzas.com/',
                                                    '_blank'
                                                )
                                            }}
                                            label="Cobranzas.com"
                                        /> -->
                                        <Button
                                            label="Descargar"
                                            style="width: 100%"
                                            on:click={(_) =>
                                                window.open(
                                                    `${API_URL}/download/${invoice.id}`
                                                )}
                                        />
                                    </span>
                                </span>
                            </ScrollBox>
                        </div>
                    {:catch}
                        <Alert type="error"
                            >La factura no existe o no tienes permisos para
                            verla.</Alert
                        >
                    {/await}
                </TopBar>
            </div>
        </BackDrop>
    </Route>
</Router>
<BackDrop
    style="z-index: 999999; position: fixed"
    visible={currentInvoice !== null}
>
    <WidgetFactura
        disable={waiting}
        update={!loadNewInvoice}
        data={currentInvoice}
        bind:disabled={waiting}
        on:submit={loadNewInvoice ? loadInvoice : updateInvoice}
        on:close={() => (currentInvoice = null)}
    />
</BackDrop>

<!-- </div> -->

<style>
    .drawer {
        position: absolute;
        min-width: 500px;
        width: 100%;
        max-width: 978px;
        right: 0;
        top: 0;
        height: 100%;
        background-color: #f6f6f6;
    }
    .search {
        width: 100%;
        height: 72px;
        position: relative;
        display: flex;
        flex-direction: row;
        gap: 15px;
        align-items: center;
        padding: 0 25px;
        justify-content: flex-start;
    }
    .search input {
        border-style: none;
        outline: none;
        font-size: 17px;
        width: 100%;
    }

    .buttonSet {
        display: flex;
        flex-direction: row;
        gap: 10px;
    }
</style>
